import { Component, ReactNode, ErrorInfo } from 'react'

interface State { error: Error | null; info: ErrorInfo | null }

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null, info: null }

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({ info })
    console.error('ErrorBoundary caught:', error, info)
  }

  render() {
    const { error, info } = this.state
    if (error) {
      return (
        <div style={{ padding: 32, fontFamily: 'monospace', fontSize: 13 }}>
          <h2 style={{ color: '#dc2626' }}>Render error — paste this to support</h2>
          <pre style={{
            background: '#f3f4f6', padding: 16, borderRadius: 8,
            whiteSpace: 'pre-wrap', wordBreak: 'break-all', overflow: 'auto',
          }}>
            {error.message}{'\n\n'}{error.stack}{'\n\n'}
            Component stack:{'\n'}{info?.componentStack}
          </pre>
        </div>
      )
    }
    return this.props.children
  }
}
